module.exports = __webpack_public_path__ + "img/DSC_2754-xs.0e41106a.png";